export const DIETS = ['VEG', 'NON_VEG', 'VEGAN', 'EGGETARIAN', 'JAIN']
export const TIERS = ['SIMPLE', 'CLASSIC', 'PREMIUM']
export const GENDERS = ['MALE', 'FEMALE', 'NON_BINARY', 'PREFER_NOT_TO_SAY']
export const WHO_WILL_PAY_OPTIONS = ['I will pay 100%', 'Split Bill', 'Home Cook Food', 'CoEater Pay 100%', 'Flip A Coin', 'I will Use Spinner','Decide After Meeting']

export const NAV_ITEMS = [
  { id: 'discover', icon: '🔍', label: 'Discover' },
  { id: 'home', icon: '🏠', label: 'Home' },
  { id: 'invites',  icon: '📬', label: 'Invites' },
  { id: 'chats',    icon: '💬', label: 'Chats' },
  { id: 'group', icon: '🍽️', label: 'Group' },
  { id: 'reels', icon: '🎬', label: 'Reels' },
  { id: 'notification', icon: '🔔', label: 'Notifications' },
  { id: 'streak', icon: '🔥', label: 'Streak' },
  { id: 'restaurants', icon: '🍴', label: 'Restaurants' },
  { id: 'schedule', icon: '📅', label: 'My Schedule' },
  { id: 'spots',    icon: '📍', label: 'Nearby Spots' },
  { id: 'spinner',  icon: '🎡', label: 'Spinner' },
  { id: 'profile',  icon: '👤', label: 'Profile' },
  { id: 'settings', icon: '⚙️', label: 'Settings' },
  { id: 'refer', icon: '🎁', label: 'Refer & Earn' },
]

export const defaultProfileForm = {
  bio: '', profilePicture: '',
  gender: '', birthYear: '',
  address: '', city: 'Bengaluru', area: '',
  dietaryType: 'VEG', budgetVibe: 'SIMPLE',
  whoWillPay: '',
  interestsInput: 'Healthy, Street Food',
  isAvailable: true, availabilityLabel: 'Looking for lunch today'
}

export const inputCls = 'w-full rounded-xl border border-orange-200 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300'
